import { Order } from "@/data/interfaces/OrderInterface";
export const getPrefixString = (string: string) => {
  if (string) {
    string = string.toUpperCase();
    const match = string.match(/^([A-Z]+)/);
    if (match) {
      const result = match[1];
      return result;
    }
  }

  return "";
};

export const getIdentifierNumber = (string: string) => {
  if (string) {
    const match = string.match(/\d+/);
    if (match) {
      const result = match[0];
      return result;
    }
  }
  return "";
};

export const populateParams = (orderItem: Order, disabled: boolean) => {
  const params = {} as any;
  if (!disabled) {
    params["loadUnit"] = {} as Order["loadUnit"];
    params["loadUnit"]["identifierPrefix"] = getPrefixString(
      orderItem?.loading_unit_formatted
    );
    params["loadUnit"]["identifierNumber"] = getIdentifierNumber(
      orderItem?.loading_unit_formatted
    );
    params["loadUnit"]["type"] = orderItem?.loadUnit?.type;
    params["loadUnit"]["heightCode"] = orderItem?.loadUnit?.heightCode;
    params["loadUnit"]["loadWeight"] = orderItem?.loadUnit?.loadWeight;
    params["loadUnit"]["emptyWeight"] = orderItem?.loadUnit?.emptyWeight;

    params["loadUnit"]["loadingStatus"] =
      orderItem?.loadUnit?.loadWeight > 0 ? "loaded" : "empty";
  }
  params["licensePlate"] = orderItem?.licensePlate;
  return params;
};
